import { cn } from "src/common/utils";

const SplunkIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1")}>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="100%" 
      height="100%"
      viewBox="0 0 64 64"
    >
      <path d="M5.396 11.93V0l53.207 26.698V37.49L5.396 64V52.26L46.675 32z" fill="#989898"/>
    </svg>
  </div>
);

export default SplunkIcon;